import localforage from "localforage";

export async function logout () {
    await localforage.setItem("339vending.admin-token", "");
}

export default logout;
